import React from "react"
import { useState, useEffect } from 'react';
import { db } from '../services/firebase';
import {withRouter} from 'react-router';

import NewsletterGridVertica from "./NewsletterGridVertica"
import NewsletterFreeForm from "./NewsletterFreeForm"

import FadeInSection from "./FadeInSection"
import IconBarSocial from "./IconBarSocial"

function SubscriberCurrentNewsletter(props){

    const [articles, setArticles] = useState([])

    useEffect(() => {
      const subscriber = db
        .collection('newsletter')
        .orderBy('timestamp', 'desc')
        .get()
        .then(snap => {
          const data = snap.docs.map(doc => doc.data())
          setArticles(data)
        });
    }, []);

    const [first, setFirst] = useState()
    const [others, setOthers] = useState([])
    const [final, setFinal] = useState([])

    useEffect(() => {
      if(articles[0]){
        setFirst(articles[0])
        setFinal([articles[articles.length-1]])
        const [, ...rest] = articles
        rest.pop()
        setOthers(rest)
      }
    }, [articles]);

    console.log(first)

      if (articles.length !== 0) {
          return (
              <div>
                {first && first.topic &&
                    <div>
                    <section>
                    <FadeInSection>
                    {/*<cr/>*/}
                    <hr/>
                    <p className="timingext">COVER</p>
                    <NewsletterGridVertica article={first}/>
                    </FadeInSection>
                    <FadeInSection>
                    {/*<cr/>*/}
                    <hr/>
                    <p className="timing">{first.topic.toUpperCase()}</p>
                    <NewsletterFreeForm article={first}/>
                    </FadeInSection>
                    </section>
                    </div>
                }
              {others[0] && others.map(article => (
                    <div>
                    <section>
                    <FadeInSection>
                    {/*<cr/>*/}
                    <hr/>
                    <p className="timing">UPCOMING</p>
                    <NewsletterGridVertica article={article}/>
                    </FadeInSection>
                    <FadeInSection>
                    {/*<cr/>*/}
                    <hr/>
                    <p className="timing">{article.topic.toUpperCase()}</p>
                    <NewsletterFreeForm article={article}/>
                    </FadeInSection>
                    </section>
                    </div>
              ))}
              {final[0] && final.map(article => (
                    <div>
                    <section>
                    <FadeInSection>
                    {/*<cr/>*/}
                    <hr/>
                    <p className="timing">UPCOMING</p>
                    <NewsletterGridVertica article={article}/>
                    </FadeInSection>
                    <FadeInSection>
                    {/*<cr/>*/}
                    <hr/>
                    <p className="timing">{article.topic.toUpperCase()}</p>
                    <NewsletterFreeForm article={article}/>
                    {/*<cr/>*/}
                    <hr/>
                    <IconBarSocial/>
                    </FadeInSection>
                    </section>
                    </div>
              ))}
              </div>
          )
      } else {
            return (
              <div>
              <p>An Error Has Occured</p>
              </div>
            )}
}

export default withRouter(SubscriberCurrentNewsletter)
